import { render, staticRenderFns } from "./ViewSettings.vue?vue&type=template&id=1cdbb1dc&scoped=true&"
import script from "./ViewSettings.vue?vue&type=script&lang=js&"
export * from "./ViewSettings.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettings.vue?vue&type=style&index=0&id=1cdbb1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbb1dc",
  null
  
)

export default component.exports